import { AppModule } from 'app/module';
import { userDislike } from 'app/userDislike';
import { JobsListHeader } from 'module/jobsListHeader/main';
import { JobsList } from 'module/jobsList/main';
import { HokifyJobsAd } from 'module/hokifyJobsAd/main';
import { Pagination } from 'module/pagination/main';
import { LoadMoreJobsButton } from 'module/loadMoreJobsButton/main';
import { JobsInfoBox } from 'module/jobsInfoBox/main';
import { EmptyResult } from 'module/emptyResult/main';
import { JobsFilterButtons } from 'module/jobsFilterButtons/main';
import { JobsProposals } from 'module/jobsProposals/main';
import { DislikeJobModal } from 'module/dislikeJobModal/main';
import { BlogBox } from 'module/blogBox/main';
import { SalaryBenchmarkDisruptor } from 'module/salaryBenchmarkDisruptor/main';
import { JobsListFallbackRadiusInfo } from 'module/jobsListFallbackRadiusInfo/main';
import { SwitchToJobSearchDisruptor } from 'module/switchToJobSearchDisruptor/main';
import { FaqList } from 'module/faqList/main';
import { trackGa4 } from 'util/googleAnalytics';
import Template from './template.hbs';
import './styles.scss';

export class JobsSearchList extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    ready() {
        let contentType = '';

        if (this.props.eventCategory === 'page: jobs') {
            contentType = 'Job Search';
        } else if (this.props.eventCategory === 'page: jobalarm') {
            contentType = 'Job Alarm';
        } else if (this.props.eventCategory === 'page: jobmatching') {
            contentType = 'Job Matching';
        } else if (this.props.eventCategory === 'page: watchlist') {
            contentType = 'Job Watchlist';
        } else if (this.props.eventCategory === 'page: company-follow') {
            contentType = 'Company Alarm';
        }

        let bottomAlreadyReached = false;

        window.addEventListener('scroll', () => {
            if (window.scrollY + window.innerHeight > this.dom.el.scrollHeight) {
                if (!this.loadMoreJobsButton?.props.active) {
                    if (!bottomAlreadyReached) {
                        bottomAlreadyReached = true;
                        trackGa4({
                            event: 'end_of_search_results',
                            content_type: contentType,
                        });
                    }
                }
            }
        });
    }

    domBindings() {
        return {
            jobsActiveList: '.m-jobsSearchList__activeJobs .m-jobsList',
            jobsInactiveList: '.m-jobsSearchList__inactiveJobs .m-jobsList',
            jobsSimilarList: '.m-jobsSearchList__similarJobs .m-jobsList',
            jobsListHeader: '.m-jobsSearchList__header .m-jobsListHeader',
            inactiveJobsListHeader: '.m-jobsSearchList__inactiveJobsHeader .m-jobsListHeader',
            jobsInfoBox: '.m-jobsSearchList__jobsInfoBox .m-jobsInfoBox',
            jobsListInfoBox: '.m-jobsSearchList__jobsListInfoBox .m-jobsInfoBox',
            hokifyJobsAd: '.m-jobsSearchList__hokifyJobsAd .m-hokifyJobsAd',
            pagination: '.m-jobsSearchList .m-pagination',
            loadMoreJobsButton: '.m-jobsSearchList .m-loadMoreJobsButton',
            emptyResult: '.m-jobsSearchList .m-emptyResult',
            filterButtons: '.m-jobsSearchList .m-jobsFilterButtons',
            boxes: ['.m-jobsSearchList__boxes'],
            jobsProposals: ['.m-jobsSearchList__box .m-jobsProposals'],
            blogBox: '.m-jobsSearchList .m-blogBox',
            salaryBenchmarkDisruptor: '.m-jobsSearchList .m-salaryBenchmarkDisruptor',
            jobsListFallbackRadiusInfo: '.m-jobsSearchList .m-jobSearchList__jobsListFallbackRadiusInfo',
            dislikeJobModal: '.m-jobsSearchList__dislikeJobModal .m-dislikeJobModal',
            switchToJobSearchDisruptor: '.m-jobsSearchList__switchToJobSearchDisruptor .m-switchToJobSearchDisruptor',
            faqList: '.m-jobsSearchList__faqList .m-faqList',
        };
    }

    getPropsFromDom() {
        return {
            isSeoView: this.dom.boxes[0].classList.contains('m-jobsSearchList__boxes--seo'),
            faq: !!this.dom.faqList,
            eventCategory: document.documentElement.getAttribute('data-event-category'),
        };
    }

    subs() {
        if (this.dom.jobsActiveList) {
            this.jobsActiveList = new JobsList(this.dom.jobsActiveList);
        }

        if (this.dom.jobsInactiveList) {
            this.jobsInactiveList = new JobsList(this.dom.jobsInactiveList);
        }

        if (this.dom.dislikeJobModal) {
            this.dislikeJobModal = new DislikeJobModal(this.dom.dislikeJobModal);
        }

        if (this.dom.jobsSimilarList) {
            this.jobsSimilarList = new JobsList(this.dom.jobsSimilarList);
        }

        if (this.dom.jobsListHeader) {
            this.jobsListHeader = new JobsListHeader(this.dom.jobsListHeader);
        }

        if (this.dom.inactiveJobsListHeader) {
            this.inactiveJobsListHeader = new JobsListHeader(this.dom.inactiveJobsListHeader);
        }

        if (this.dom.filterButtons) {
            this.filterButtons = new JobsFilterButtons(this.dom.filterButtons);
        }

        if (this.dom.emptyResult) {
            this.emptyResult = new EmptyResult(this.dom.emptyResult);
        }
        if (this.dom.hokifyJobsAd) {
            this.hokifyJobsAd = new HokifyJobsAd(this.dom.hokifyJobsAd);
        }

        if (this.dom.pagination) {
            this.pagination = new Pagination(this.dom.pagination);
        }

        if (this.dom.loadMoreJobsButton) {
            this.loadMoreJobsButton = new LoadMoreJobsButton(this.dom.loadMoreJobsButton);
        }

        if (this.dom.jobsInfoBox) {
            this.jobsInfoBox = new JobsInfoBox(this.dom.jobsInfoBox);
        }

        if (this.dom.jobsListInfoBox) {
            this.jobsListInfoBox = new JobsInfoBox(this.dom.jobsListInfoBox);
        }

        if (this.dom.jobsProposals) {
            this.jobsProposals = [];
            for (let i = 0; i < this.dom.jobsProposals.length; i += 1) {
                this.jobsProposals[i] = new JobsProposals(this.dom.jobsProposals[i]);
            }
        }

        if (this.dom.blogBox) {
            this.blogBox = new BlogBox(this.dom.blogBox);
        }

        if (this.dom.salaryBenchmarkDisruptor) {
            this.salaryBenchmarkDisruptor = new SalaryBenchmarkDisruptor(this.dom.salaryBenchmarkDisruptor);
        }

        if (this.dom.jobsListFallbackRadiusInfo) {
            this.jobsListFallbackRadiusInfo = new JobsListFallbackRadiusInfo(this.dom.jobsListFallbackRadiusInfo);
        }

        if (this.dom.switchToJobSearchDisruptor) {
            this.switchToJobSearchDisruptor = new SwitchToJobSearchDisruptor(this.dom.switchToJobSearchDisruptor);
        }

        if (this.dom.faqList) {
            this.faqList = new FaqList(this.dom.faqList);
        }
    }

    removeSeoView() {
        this.props.isSeoView = false;
        for (let i = 0; i < this.dom.boxes.length; i += 1) {
            this.dom.boxes[i].classList.remove('m-jobsSearchList__boxes--seo');
        }
        this.switchToJobSearchDisruptor?.removeSeoView();
    }

    subEvents() {
        userDislike.events.on('showDislikeModal', (dislikeObject) => {
            this.dislikeJobModal?.openModalViaClick(
                dislikeObject.arguments[0],
                dislikeObject.arguments[1],
                dislikeObject.arguments[2],
                dislikeObject.arguments[3],
                dislikeObject.arguments[4],
            );
        });

        this.propagateEvents(this.jobsActiveList, 'jobClick');
        this.propagateEvents(this.jobsActiveList, 'openMemoTab');
        this.propagateEvents(this.jobsActiveList, 'openLoginModal');
        this.propagateEvents(this.jobsActiveList, 'removeModalStyle');
        this.propagateEvents(this.jobsActiveList, 'addModalStyle');
        this.propagateEvents(this.jobsActiveList, 'jobAlarmResponseSuccess');
        this.propagateEvents(this.jobsActiveList, 'onDislikeCompany');
        this.propagateEvents(this.jobsActiveList, 'onUndoDislikeCompany');

        this.propagateEvents(this.filterButtons, 'changedFilter');
        this.propagateEvents(this.filterButtons, 'radiusRemoved');
        this.propagateEvents(this.filterButtons, 'jobsFilterButtonClicked');

        this.propagateEvents(this.pagination, 'changed');

        this.propagateEvents(this.loadMoreJobsButton, 'load');

        this.jobsActiveList.events.on('removedJobItem', (e) => {
            this.events.emit('removedJobItem', e.arguments[0], e.arguments[1], e.arguments[2], e.arguments[3]);
        });

        this.propagateEvents(this.dislikeJobModal, 'pushStateJobDislikeModal');
        this.propagateEvents(this.dislikeJobModal, 'addModalStyle');
        this.propagateEvents(this.dislikeJobModal, 'removeModalStyle');

        for (let i = 0; i < this.jobsProposals?.length; i += 1) {
            this.propagateEvents(this.jobsProposals[i], 'proposalLinkClicked');
        }

        if (this.jobsInactiveList) {
            this.jobsActiveList.events.on('jobClick', () => this.jobsInactiveList.removeHighlightedJobItems());
            this.jobsActiveList.events.on('openMemoTab', () => this.jobsInactiveList.removeHighlightedJobItems());
            this.jobsInactiveList.events.on('jobClick', () => this.jobsActiveList.removeHighlightedJobItems());
            this.jobsInactiveList.events.on('openMemoTab', () => this.jobsActiveList.removeHighlightedJobItems());

            if (this.jobsSimilarList) {
                this.jobsSimilarList.events.on('jobClick', () => this.jobsActiveList.removeHighlightedJobItems());
                this.jobsSimilarList.events.on('jobClick', () => this.jobsInactiveList.removeHighlightedJobItems());
                this.jobsActiveList.events.on('jobClick', () => this.jobsSimilarList.removeHighlightedJobItems());
                this.jobsActiveList.events.on('openMemoTab', () => this.jobsSimilarList.removeHighlightedJobItems());
                this.jobsInactiveList.events.on('jobClick', () => this.jobsSimilarList.removeHighlightedJobItems());
                this.jobsInactiveList.events.on('openMemoTab', () => this.jobsSimilarList.removeHighlightedJobItems());
                this.propagateEvents(this.jobsSimilarList, 'jobClick');
            }

            this.propagateEvents(this.jobsInactiveList, 'jobClick');
            this.propagateEvents(this.jobsInactiveList, 'openMemoTab');
            this.propagateEvents(this.jobsInactiveList, 'removeModalStyle');
            this.propagateEvents(this.jobsInactiveList, 'addModalStyle');
            this.jobsInactiveList.events.on('removedJobItem', (e) => {
                this.events.emit('removedJobItem', e.arguments[0], e.arguments[1], e.arguments[2], e.arguments[3]);
            });
            this.jobsInactiveList.events.on('hideHeadline', () => {
                this.inactiveJobsListHeader?.hideHeadline();
            });

            this.jobsInactiveList.events.on('showHeadline', () => {
                this.inactiveJobsListHeader?.showHeadline();
            });
        } else if (this.jobsSimilarList) {
            this.jobsActiveList.events.on('jobClick', () => this.jobsSimilarList.removeHighlightedJobItems());
            this.jobsSimilarList.events.on('jobClick', () => this.jobsActiveList.removeHighlightedJobItems());

            this.propagateEvents(this.jobsSimilarList, 'jobClick');
            this.propagateEvents(this.jobsSimilarList, 'removeModalStyle');
            this.propagateEvents(this.jobsSimilarList, 'addModalStyle');
        }

        this.propagateEvents(this.jobsListInfoBox, 'openEditModal');
        this.propagateEvents(this.jobsListInfoBox, 'openLoginModal');
        this.propagateEvents(this.jobsListInfoBox, 'passWithHash');

        this.propagateEvents(this.jobsInfoBox, 'openEditModal');

        this.propagateEvents(this.jobsListFallbackRadiusInfo, 'openEditModal');
    }

    removeHighlightedJobItems() {
        this.jobsActiveList.removeHighlightedJobItems();
        this.jobsInactiveList?.removeHighlightedJobItems();
        this.jobsSimilarList?.removeHighlightedJobItems();
    }

    insideListing(selectedJobId) {
        const isInActiveList = this.jobsActiveList?.insideListing(selectedJobId);
        const isInSimilarList = this.jobsSimilarList?.insideListing(selectedJobId);
        const isInInactiveList = this.jobsInactiveList?.insideListing(selectedJobId);

        return !!(isInActiveList || isInInactiveList || isInSimilarList);
    }

    insideListingWatched(selectedJobId) {
        const isInActiveList = this.jobsActiveList?.insideListingWatched(selectedJobId);
        const isInSimilarList = this.jobsSimilarList?.insideListing(selectedJobId);
        const isInInactiveList = this.jobsInactiveList?.insideListingWatched(selectedJobId);

        return !!(isInActiveList || isInInactiveList || isInSimilarList);
    }

    highlightJobItem(selectedJobId, onReady) {
        this.jobsActiveList.highlightJobItem(selectedJobId, onReady);
        this.jobsInactiveList?.highlightJobItem(selectedJobId, onReady);
        this.jobsSimilarList?.highlightJobItem(selectedJobId, onReady);
    }

    updateInfoBox(props) {
        this.jobsInfoBox.updateProps(props, true);
    }

    onJobalarmResponseSuccess(response) {
        this.jobsActiveList?.onJobalarmResponseSuccess(response);
    }

    onJobAlarmRemoveResponse(response) {
        this.jobsActiveList?.onJobAlarmRemoveResponse(response);
    }

    updateShowMemoButtonStates(showMemoButton, jobId) {
        this.jobsActiveList?.updateShowMemoButtonStates(showMemoButton, jobId);
        this.jobsInactiveList?.updateShowMemoButtonStates(showMemoButton, jobId);
    }
}
